// Lista curada de indicativos telefónicos — compartida entre el selector de
// desktop (SearchBar/PhoneSegment) y el de mobile (MobileFlow/PhoneDialCodeSelector)
// para no duplicar la lista de países.
export const DIAL_CODES = [
  { code: 'AR', name: 'Argentina',         dialCode: '+54',  flag: '🇦🇷' },
  { code: 'BO', name: 'Bolivia',           dialCode: '+591', flag: '🇧🇴' },
  { code: 'BR', name: 'Brasil',            dialCode: '+55',  flag: '🇧🇷' },
  { code: 'CA', name: 'Canadá',            dialCode: '+1',   flag: '🇨🇦' },
  { code: 'CL', name: 'Chile',             dialCode: '+56',  flag: '🇨🇱' },
  { code: 'CO', name: 'Colombia',          dialCode: '+57',  flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica',        dialCode: '+506', flag: '🇨🇷' },
  { code: 'EC', name: 'Ecuador',           dialCode: '+593', flag: '🇪🇨' },
  { code: 'SV', name: 'El Salvador',       dialCode: '+503', flag: '🇸🇻' },
  { code: 'ES', name: 'España',            dialCode: '+34',  flag: '🇪🇸' },
  { code: 'GT', name: 'Guatemala',         dialCode: '+502', flag: '🇬🇹' },
  { code: 'HN', name: 'Honduras',          dialCode: '+504', flag: '🇭🇳' },
  { code: 'MX', name: 'México',            dialCode: '+52',  flag: '🇲🇽' },
  { code: 'PA', name: 'Panamá',            dialCode: '+507', flag: '🇵🇦' },
  { code: 'PY', name: 'Paraguay',          dialCode: '+595', flag: '🇵🇾' },
  { code: 'PE', name: 'Perú',              dialCode: '+51',  flag: '🇵🇪' },
  { code: 'DO', name: 'R. Dominicana',     dialCode: '+1829',flag: '🇩🇴' },
  { code: 'UY', name: 'Uruguay',           dialCode: '+598', flag: '🇺🇾' },
  { code: 'US', name: 'USA',               dialCode: '+1',   flag: '🇺🇸' },
  { code: 'VE', name: 'Venezuela',         dialCode: '+58',  flag: '🇻🇪' },
];

// strict=true evita el fallback (usado cuando solo queremos saber si el país
// tiene un indicativo soportado en la lista, ej. al sincronizar con el origen)
export const getDialEntry = (countryCode, strict = false) => {
  const found = DIAL_CODES.find(d => d.code === countryCode);
  if (found) return found;
  return strict ? null : DIAL_CODES[0];
};

export const parsePhoneValue = (value, dialEntry) => {
  if (!value) return '';
  if (dialEntry && value.startsWith(dialEntry.dialCode)) {
    return value.slice(dialEntry.dialCode.length);
  }
  return value.replace(/^\+\d+/, '');
};

export const PHONE_ERROR_MESSAGE = 'Revisa tu número para conocer tu cotización';
